import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getOrganizedUnitTree from '../../services/organizedUnit/getOrganizedUnitTree'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchOrganizedUnitsTreeSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchOrganizedUnitsTree () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const UOTreeCombo = yield call(getOrganizedUnitTree, auth.token)
    yield put(fetchOrganizedUnitsTreeSuccess(UOTreeCombo))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchOrganizedUnitsTree () {
  yield takeLatest(combosActionTypes.FETCH_ORGANIZED_UNITS_TREE, fetchOrganizedUnitsTree)
}
